import React, { useState, useEffect } from "react";
import LayoutContent from "../../LayoutContent";
import Header from "../../Header/Header";
import Breadcrumb from "../../Header/Breadcrumb";
import HeaderButton from "../../Header/HeaderButton";
import IconDebug from "../../../Icons/TopCommandPanel/Debug";
import ToolsNavSubMenu from "../ToolsNavSubMenu";
import ToolsApi from "../../../api/ToolsApi";
import { SmtpSetting } from "../../../Model/SmtpSetting";
import SimpleCard from "../../Cards/SimpleCard";
import PredefinedEmail from "./PredefinedEmail";
import "./ToolsEmail.css";
import CustomEmail from "./CustomEmail";

type ToolsEmailType = "tools-predefined-email" | "tools-custom-email";

export default function Email() {
  const [selectedEmailType, setSelectedEmailType] = useState(
    "tools-predefined-email" as ToolsEmailType
  );

  return (
    <LayoutContent>
      <LayoutContent.Header>
        <Header>
          <Breadcrumb
            items={[
              {
                title: "Email",
                to: "/tools/email",
                disabled: false,
              },
            ]}
          />
          <Header.RightSide>
            <HeaderButton
              id={"DEBUG_PAGE"}
              label="Debug"
              icon={<IconDebug />}
              onClick={(id) => {
                window.open("/debug", "debugpage");
              }}
            />
          </Header.RightSide>
        </Header>
      </LayoutContent.Header>
      <LayoutContent.SubMenu>
        <ToolsNavSubMenu />
      </LayoutContent.SubMenu>
      <LayoutContent.Content style={{ paddingTop: 16, paddingLeft: 16 }}>
        <div className="tools-email">
          <SimpleCard
            style={{
              width: 582,
            }}
          >
            <SimpleCard.Header
              title="Predefined Email"
              useRadioButton={true}
              radioButtonId="tools-predefined-email"
              radioButtonName="tools-predefined-email"
              isRadioButtonSelected={
                selectedEmailType === "tools-predefined-email"
              }
              radioButtonOnChange={(id) => {
                setSelectedEmailType(id as ToolsEmailType);
              }}
            />
            <PredefinedEmail
              disabled={selectedEmailType !== "tools-predefined-email"}
            />
          </SimpleCard>
          <SimpleCard
            style={{
              width: 582,
            }}
          >
            <SimpleCard.Header
              title="Custom Email"
              useRadioButton={true}
              radioButtonId="tools-custom-email"
              radioButtonName="tools-custom-email"
              isRadioButtonSelected={selectedEmailType === "tools-custom-email"}
              radioButtonOnChange={(id) => {
                setSelectedEmailType(id as ToolsEmailType);
              }}
            />
            <CustomEmail
              disabled={selectedEmailType !== "tools-custom-email"}
            />
          </SimpleCard>
        </div>
      </LayoutContent.Content>
    </LayoutContent>
  );
}
